import UserDatabases from '@Services/UserDatabases';
import map from 'lodash/map';
import some from 'lodash/some';
import find from 'lodash/find';
import filter from 'lodash/filter';
import get from 'lodash/get';
import { SHOPPING_TOOLTIP_NOT_AVAILABLE } from '@Components/Results/structure/availability/ShoppingCartTooltipContent';

const RETRY_AVAILABILITY = 15000;
const statusCache = {};

export const SHOPPING_CART_TIER_1 = 'Up to 5 days';

export const getShoppingCartIcon = (details) =>
  get(details, 'shippingTime', SHOPPING_TOOLTIP_NOT_AVAILABLE) === SHOPPING_CART_TIER_1 ? 'RapidDelivery' : 'ShoppingCart';

export const getShoppingCartIconRt = (details) =>
  get(details, 'shippingTime', SHOPPING_TOOLTIP_NOT_AVAILABLE) === SHOPPING_CART_TIER_1
    ? '#icon-shopping-cart-rapid'
    : '#icon-shopping-cart';

export const loadShoppingCartImage = (provider, retry = true) => {
  return new Promise((resolve) => {
    const img = new Image();

    img.src = provider.imageUrl;
    img.onload = () => {
      // eslint-disable-next-line no-param-reassign
      provider.show = img.height !== 1;
      resolve(provider);
    };

    // eslint-disable-next-line no-multi-assign
    img.onabort = img.onerror = () => {
      if (retry) {
        setTimeout(() => loadShoppingCartImage(provider, false), RETRY_AVAILABILITY);
      } else {
        // eslint-disable-next-line no-param-reassign
        provider.show = false;
      }
      resolve(provider);
    };
  });
};

const checkCustomerSpecificProviders = (customerSpecificProviders, resolve) => {
  const promises = map(customerSpecificProviders, loadShoppingCartImage);
  return Promise.all(promises)
    .then((providers) => (some(providers, { show: true }) && resolve(true)) || resolve(false))
    .catch(Logger.error);
};

export const shoppingCartStatusCheck = async ({ availability, structure, allowCommercialDBOnly = false }) =>
  new Promise((resolve) => {
    const statusProvider = find(availability.providers, { custom: true }) || {};
    const customerSpecificProviders = filter(availability.providers, ({ custom, imageUrl }) => custom && imageUrl);
    const statusUrl = availability.url || statusProvider.imageUrl;
    const databaseId = get(structure, 'databaseId');

    const commercialSubstances =
      find(get(structure, 'subLinks'), { databaseId: '20' }) && (allowCommercialDBOnly || UserDatabases.isDefaultDatabase(databaseId));
    if (commercialSubstances) {
      resolve(true);
    } else if (statusUrl) {
      if (statusCache[statusUrl]) {
        resolve(statusCache[statusUrl]);
      } else {
        const img = new Image();

        img.src = statusUrl;
        img.onload = () => {
          const status = img.height !== 1;
          if (!status && customerSpecificProviders.length) {
            /* For other CI customers we might have their own providers, and their availability can't be
             * checked in a same way as for the other providers. So in case if cart is unavailable after regular check
             * and there are some customer specific providers in a list - check each of those so see, if they has
             * available image via imageUrl */
            checkCustomerSpecificProviders(customerSpecificProviders, resolve);
          } else {
            statusCache[statusUrl] = status;
            resolve(status);
          }
        };
        // eslint-disable-next-line no-multi-assign
        img.onabort = img.onerror = () => resolve(false);
      }
    } else {
      resolve(false);
    }
  });
